import { buildIcon } from './uitk-eg-map-helper.esm.js';
import { UitkEGMapsUitkIconType, UitkEGMapsQualifier } from '../types/uitk-eg-map-marker-type.esm.js';
var extractRGBA = function (color) {
  if (color) {
    if (color.startsWith('#')) return {
      rgb: color,
      alpha: 1.0
    };
    if (color.startsWith('rgb(')) return {
      rgb: color,
      alpha: 1.0
    };
    if (color.startsWith('rgba(')) {
      var _a = /rgba\(([0-9, ]*),[ ]*([0-9.]*)[ ]*\)/.exec(color) || [],
        rgb = _a[1],
        alpha = _a[2];
      if (rgb) return {
        rgb: "rgb(".concat(rgb, ")"),
        alpha: parseFloat(alpha)
      };
    }
  }
  return {
    rgb: color || 'rgb(0, 0, 0)',
    alpha: 1.0
  };
};
var primaryIconClass = 'uitk-eg-maps-primary-icon';
var secondaryIconClass = 'uitk-eg-maps-secondary-icon';
var DEFAULT_FONT_SIZE = '16px';
var convertRemToPixels = function (rem) {
  var _a;
  return parseFloat(rem) * parseFloat(((_a = getComputedStyle(document.documentElement)) === null || _a === void 0 ? void 0 : _a.fontSize) || DEFAULT_FONT_SIZE);
};
var defaultEGMapsConfig = function (brand, getCssValue) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
  var _l, _m, _o, _p;
  var routeColor = extractRGBA((_l = getCssValue('--uitk-map__route__border_color')) === null || _l === void 0 ? void 0 : _l.trim());
  var routeBorder = (_m = getCssValue('--uitk-map__route__border_width')) === null || _m === void 0 ? void 0 : _m.trim();
  var routeBorderPixels = (routeBorder === null || routeBorder === void 0 ? void 0 : routeBorder.includes('rem')) ? convertRemToPixels(routeBorder) : routeBorder;
  var routeSize = typeof routeBorderPixels === 'string' ? parseInt(routeBorderPixels, 10) : routeBorderPixels;
  var obfuscateAreaFillColor = extractRGBA((_o = getCssValue('--uitk-map__obfuscate_fill_color')) === null || _o === void 0 ? void 0 : _o.trim());
  var obfuscateAreaLineColor = extractRGBA((_p = getCssValue('--uitk-map__obfuscate_line_color')) === null || _p === void 0 ? void 0 : _p.trim());
  var obfuscateAreaLineWeight = parseInt(getCssValue('background-position-x') || '1', 10);
  var soldOutIcon = buildIcon(UitkEGMapsUitkIconType.SOLD_OUT, primaryIconClass, brand);
  var product = {
    show: {
      available: true,
      sold_out: true,
      unknown: true
    },
    markerType: (_a = {
      sold_out: 'pin',
      available: 'price',
      booking: 'pin'
    }, _a[UitkEGMapsQualifier.OBFUSCATED] = 'obfuscate', _a[UitkEGMapsQualifier.OBFUSCATED_PIN] = 'pinObfuscate', _a[UitkEGMapsQualifier.OBFUSCATED_PRICE] = 'priceObfuscate', _a),
    icons: (_b = {
      hl: null,
      available: null,
      default: buildIcon(UitkEGMapsUitkIconType.HOTEL, primaryIconClass, brand)
    }, _b["".concat(UitkEGMapsQualifier.HOTEL, "#sold_out")] = soldOutIcon, _b["".concat(UitkEGMapsQualifier.CAR, "#sold_out")] = soldOutIcon, _b["".concat(UitkEGMapsQualifier.VACATION_RENTAL, "#sold_out")] = soldOutIcon, _b["".concat(UitkEGMapsQualifier.OBFUSCATED_PIN, "#sold_out")] = soldOutIcon, _b["".concat(UitkEGMapsQualifier.AIRPORT, "#sold_out")] = soldOutIcon, _b["".concat(UitkEGMapsQualifier.ACTIVITY, "#sold_out")] = soldOutIcon, _b["".concat(UitkEGMapsQualifier.CRUISE, "#sold_out")] = soldOutIcon, _b.sold_out = soldOutIcon, _b[UitkEGMapsQualifier.HOTEL] = buildIcon(UitkEGMapsUitkIconType.HOTEL, primaryIconClass, brand), _b[UitkEGMapsQualifier.CAR] = buildIcon(UitkEGMapsUitkIconType.CAR, primaryIconClass, brand), _b[UitkEGMapsQualifier.VACATION_RENTAL] = buildIcon(UitkEGMapsUitkIconType.VACATION_RENTAL, primaryIconClass, brand), _b[UitkEGMapsQualifier.AIRPORT] = buildIcon(UitkEGMapsUitkIconType.AIRPORT, primaryIconClass, brand), _b[UitkEGMapsQualifier.ACTIVITY] = buildIcon(UitkEGMapsUitkIconType.ACTIVITY, primaryIconClass, brand), _b[UitkEGMapsQualifier.CRUISE] = buildIcon(UitkEGMapsUitkIconType.CRUISE, primaryIconClass, brand), _b),
    frameIcons: (_c = {
      default: 'pin'
    }, _c[UitkEGMapsQualifier.OBFUSCATED_PIN] = 'circle', _c),
    zIndex: {
      default: 10,
      hl: 20,
      available: 12,
      filtered: 11,
      sold_out: 10,
      unknown: null
    },
    cornerIcons: {
      topRight: (_d = {}, _d[UitkEGMapsQualifier.SAVED] = buildIcon(UitkEGMapsUitkIconType.SAVED, secondaryIconClass, brand), _d)
    },
    innerIcons: {
      left: (_e = {}, _e[UitkEGMapsQualifier.MEMBER_DEAL] = buildIcon(UitkEGMapsUitkIconType.ONEKEYCOIN, primaryIconClass, brand), _e),
      right: (_f = {}, _f[UitkEGMapsQualifier.BOOKED] = buildIcon(UitkEGMapsUitkIconType.CHECK_CIRCLE, primaryIconClass, brand), _f)
    },
    minZoomForDisplay: {
      default: -1
    },
    clustering: {
      default: {
        type: 'supercluster',
        excludedQualifiers: [UitkEGMapsQualifier.NOT_CLUSTERED],
        superclusterSettings: {
          radius: 105
        },
        maxZoom: 15,
        minPoints: 10
      }
    },
    obfuscateMarkers: {
      radiusInM: {
        default: 1000
      },
      style: {
        default: {
          line: {
            weight: obfuscateAreaLineWeight,
            color: obfuscateAreaLineColor === null || obfuscateAreaLineColor === void 0 ? void 0 : obfuscateAreaLineColor.rgb,
            opacity: obfuscateAreaLineColor === null || obfuscateAreaLineColor === void 0 ? void 0 : obfuscateAreaLineColor.alpha
          },
          fill: {
            color: obfuscateAreaFillColor === null || obfuscateAreaFillColor === void 0 ? void 0 : obfuscateAreaFillColor.rgb,
            opacity: obfuscateAreaFillColor === null || obfuscateAreaFillColor === void 0 ? void 0 : obfuscateAreaFillColor.alpha
          }
        },
        hl: {
          line: {
            weight: obfuscateAreaLineWeight,
            color: obfuscateAreaLineColor === null || obfuscateAreaLineColor === void 0 ? void 0 : obfuscateAreaLineColor.rgb,
            opacity: obfuscateAreaLineColor === null || obfuscateAreaLineColor === void 0 ? void 0 : obfuscateAreaLineColor.alpha
          },
          fill: {
            color: obfuscateAreaFillColor === null || obfuscateAreaFillColor === void 0 ? void 0 : obfuscateAreaFillColor.rgb,
            opacity: obfuscateAreaFillColor === null || obfuscateAreaFillColor === void 0 ? void 0 : obfuscateAreaFillColor.alpha
          }
        }
      }
    }
  };
  var mapConfig = {
    markers: {
      product: product,
      property: product,
      place: {
        show: {
          default: true,
          unknown: true
        },
        markerType: {
          default: 'pin'
        },
        minZoomForDisplay: {
          default: -1
        },
        threshold: {
          default: 1000
        },
        icons: (_g = {
          default: buildIcon(UitkEGMapsUitkIconType.POI, primaryIconClass, brand),
          unknown: null,
          hl: null
        }, _g[UitkEGMapsQualifier.AIRPORT] = buildIcon(UitkEGMapsUitkIconType.AIRPORT, primaryIconClass, brand), _g[UitkEGMapsQualifier.RESTAURANT] = buildIcon(UitkEGMapsUitkIconType.RESTAURANT, primaryIconClass, brand), _g["".concat(UitkEGMapsQualifier.RESTAURANT, "#").concat(UitkEGMapsQualifier.GROCERY)] = buildIcon(UitkEGMapsUitkIconType.RESTAURANT, primaryIconClass, brand), _g[UitkEGMapsQualifier.FOOD_AND_DRINKS] = buildIcon(UitkEGMapsUitkIconType.FOOD_AND_DRINKS, primaryIconClass, brand), _g[UitkEGMapsQualifier.CAR] = buildIcon(UitkEGMapsUitkIconType.CAR, primaryIconClass, brand), _g[UitkEGMapsQualifier.GROCERY] = buildIcon(UitkEGMapsUitkIconType.GROCERY, primaryIconClass, brand), _g[UitkEGMapsQualifier.FOOD_STORE] = buildIcon(UitkEGMapsUitkIconType.FOOD_STORE, primaryIconClass, brand), _g[UitkEGMapsQualifier.CONVENIENCE] = buildIcon(UitkEGMapsUitkIconType.CONVENIENCE, primaryIconClass, brand), _g[UitkEGMapsQualifier.TRANSPORTATION] = buildIcon(UitkEGMapsUitkIconType.TRANSPORTATION, primaryIconClass, brand), _g[UitkEGMapsQualifier.METRO_STATION] = buildIcon(UitkEGMapsUitkIconType.METRO_STATION, primaryIconClass, brand), _g[UitkEGMapsQualifier.BUS_STATION] = buildIcon(UitkEGMapsUitkIconType.BUS_STATION, primaryIconClass, brand), _g[UitkEGMapsQualifier.PARKING] = buildIcon(UitkEGMapsUitkIconType.PARKING, primaryIconClass, brand), _g[UitkEGMapsQualifier.PEOPLE] = buildIcon(UitkEGMapsUitkIconType.PEOPLE, primaryIconClass, brand), _g[UitkEGMapsQualifier.PERSON] = buildIcon(UitkEGMapsUitkIconType.PERSON, primaryIconClass, brand), _g[UitkEGMapsQualifier.ACTIVITY] = buildIcon(UitkEGMapsUitkIconType.ACTIVITY, primaryIconClass, brand), _g),
        frameIcons: (_h = {
          default: 'pin'
        }, _h[UitkEGMapsQualifier.OBFUSCATED_PIN] = 'circle', _h),
        zIndex: (_j = {
          default: 1,
          unknown: null,
          hl: 20
        }, _j[UitkEGMapsQualifier.AIRPORT] = 3, _j[UitkEGMapsQualifier.METRO_STATION] = 3, _j[UitkEGMapsQualifier.BUS_STATION] = 3, _j[UitkEGMapsQualifier.TRANSPORTATION] = 3, _j[UitkEGMapsQualifier.LANDMARK] = 3, _j[UitkEGMapsQualifier.POINT_OF_INTEREST] = 3, _j),
        cornerIcons: {
          topRight: (_k = {}, _k[UitkEGMapsQualifier.SAVED] = buildIcon(UitkEGMapsUitkIconType.SAVED, secondaryIconClass, brand), _k)
        }
      },
      cluster: {
        zIndex: {
          default: 9,
          hl: 20
        }
      }
    },
    routes: {
      style: {
        driving: {
          lineStyle: 'normal',
          color: routeColor.rgb,
          width: routeSize,
          opacity: routeColor.alpha
        },
        cycling: {
          lineStyle: 'normal',
          color: routeColor.rgb,
          width: routeSize,
          opacity: routeColor.alpha
        },
        walking: {
          lineStyle: 'normal',
          color: routeColor.rgb,
          width: routeSize,
          opacity: routeColor.alpha
        },
        flying: {
          color: routeColor.rgb,
          opacity: routeColor.alpha
        }
      }
    }
  };
  return mapConfig;
};
var getCircularReplacer = function () {
  var seen = new WeakSet();
  return function (key, value) {
    if (typeof value === 'object' && value !== null) {
      if (seen.has(value)) {
        return;
      }
      seen.add(value);
    }
    return value;
  };
};
var isAnHtmlElement = function (comp) {
  if (comp) return comp.nodeName !== undefined;
  return false;
};
var isObject = function (elt) {
  return elt !== null && typeof elt === 'object' && !isAnHtmlElement(elt) && Object.prototype.toString.call(elt) !== '[object Array]';
};
/**
 * Sort all arrays deeply in object
 *
 * @param {any} obj
 * @returns {any}
 */
var sortDeeplyObjectAndArray = function (obj) {
  var _a;
  if (obj) {
    if (Array.isArray(obj)) return obj.sort();
    if (isObject(obj)) {
      if (((_a = obj.constructor) === null || _a === void 0 ? void 0 : _a.name) === 'Object') {
        var ret_1 = {};
        Object.keys(obj).sort().forEach(function (k) {
          ret_1[k] = sortDeeplyObjectAndArray(obj[k]);
        });
        return ret_1;
      }
      return obj;
    }
    return obj;
  }
  return obj;
};
/**
 * Stringify an object
 *
 * @param {any} elt
 * @returns {String}
 */
var stringify = function (elt) {
  return JSON.stringify(elt, getCircularReplacer());
};
export { defaultEGMapsConfig, extractRGBA, sortDeeplyObjectAndArray, stringify };